._ClientDetails_vw6um_1 {
  /* Empty file & class, used as a placeholder for future styling */
}